import c from "classnames";
import { ComponentProps } from "react";
import { NavLink } from "react-router";

import { Icon } from "@design-system/Icon/Icon";
import { Text } from "@design-system/Text/Text";

import classes from "./Tab.module.css";

type Props = {
  name: string;
  to: string;
  icon?: ComponentProps<typeof Icon>["icon"];
};

export const Tab = ({ name, to, icon }: Props) => {
  return (
    <NavLink
      className={({ isActive }) => c(classes.tab, isActive && classes.active)}
      to={to}
      viewTransition
      draggable={false}
    >
      {icon && <Icon icon={icon} />}
      <Text color="inherit" weight={500}>
        {name}
      </Text>
    </NavLink>
  );
};
